import { ProblemQuery } from "@deliverr/ui-facility/lib-facility/types";
import { parse } from "qs";

export const getShippingMethod = () => {
  const search = window.location.search.slice(1);
  const searchParams: ProblemQuery = parse(search.toLowerCase());
  const { method } = searchParams;
  return method.toUpperCase();
};
